<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form label-width="120px" :model="editForm" ref="editForm">
      <el-row>
        <el-form-item label="业务员" prop="inSalesman">
          <el-autocomplete
            size="small"
            v-model="editForm.inSalesman"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, editForm, 'inSalesman')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
       <el-row>
        <el-form-item label="客户类型" prop="cusType">
            <el-select v-model="editForm.cusType" placeholder="">
              <el-option
                  v-for="item in customerType"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
              ></el-option>
            </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="所在户" prop="account">
            <el-select v-model="editForm.account" placeholder="">
              <el-option
                  v-for="item in addTableData"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
              ></el-option>
            </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="是否线上" prop="isOutLine">
          <el-checkbox
              size="small"
              :false-label="1"
              :true-label="0"
              v-model="editForm.isOutLine"
              placeholder="是否线上"
          ></el-checkbox>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { listSalesman } from "@/api/system/user";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({
        isOutLine: 0, //0 线上；1 线下
      }),
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      addTableData:[
      {"key":"a","value":"    A"},
        {"key":"b","value":"    B"},
        {"key":"c","value":"    C"},
        {"key":"d","value":"    D"},
        {"key":"e","value":"    E"},
        {"key":"f","value":"    F"},
        {"key":"g","value":"    G"},
        {"key":"h","value":"    H"},
      ],
      customerType:[
        {"key":"C_1","value":"公司客户"},
        {"key":"C_2","value":"中介"},
        {"key":"C_3","value":"终端客户"},
      ]
    };
  },
  methods: {
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, originData, type) {
      if (data) {
        if (type === "inSalesman") {
          originData.inSalesman = data.realName;
          originData.inSalesmanId = data.id;
        }
      }
    },
    handleSubmit() {
      if(!this.editForm.account){
        this.$message.warning("未选择所在户，无法操作！");
        return;
      }
       if(!this.editForm.cusType){
        this.$message.warning("未选择客户类型，无法操作！");
        return;
      }
      this.$emit("confirm", this.editForm);
      this.handleClose();
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-capture/batch.vue